import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Meta from "vue-meta";

import { guard } from "@/guard/RouteGuard";
import { constant } from "@/plugins";

Vue.use(VueRouter);
Vue.use(Meta);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "404",
    component: () => import("../views/404/404.vue"),
  },
  {
    path: "*",
    redirect: {
      name: "404",
    },
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () => import("../views/404/Home.vue"),
  //   beforeEnter: (to, from, next) => {
  //     guard.publicGuard(next);
  //   },
  // },
  // {
  //   path: "/auth",
  //   name: "Auth",
  //   component: () => import("../views/auth/Auth.vue"),
  //   children: [
  //     {
  //       path: "registration",
  //       name: "Registration",
  //       component: () => import("../views/auth/registration/Registration.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.authGuard(next);
  //       },
  //     },
  //     {
  //       path: "login",
  //       name: "Login",
  //       component: () => import("../views/auth/login/Login.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.authGuard(next);
  //       },
  //     },
  //     {
  //       path: "email-verified",
  //       name: "EmailVerified",
  //       component: () =>
  //         import("../views/auth/email-verified/EmailVerified.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.authGuard(next);
  //       },
  //     },
  //     {
  //       path: "mobile-register",
  //       name: "MobileRegister",
  //       component: () =>
  //         import("../views/auth/mobile-register/MobileRegister.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.authGuard(next);
  //       },
  //     },
  //     {
  //       path: "forgot-password",
  //       name: "ForgotPassword",
  //       component: () =>
  //         import("../views/auth/forgot-password/ForgotPassword.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.authGuard(next);
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/artwork",
  //   name: "Artwork",
  //   component: () => import("../views/artwork/Artwork.vue"),
  //   children: [
  //     {
  //       path: "upload",
  //       name: "Upload",
  //       component: () => import("../views/artwork/upload/Upload.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.privateGuard(next);
  //       },
  //     },
  //     // {
  //     //   path: "download",
  //     //   name: "Download",
  //     //   component: () => import("../views/artwork/download/Download.vue"),
  //     //   beforeEnter: (to, from, next) => {
  //     //     guard.privateGuard(next);
  //     //   },
  //     // },
  //     {
  //       path: "artboard",
  //       name: "Artboard",
  //       component: () => import("../views/artwork/artboard/Artboard.vue"),
  //       beforeEnter: (to, from, next) => {
  //         guard.publicGuard(next);
  //       },
  //     },
  //   ],
  // },
  // // {
  // //   path: "/test-env",
  // //   name: "TestEnv",
  // //   component:
  // //     constant.MODE === "development"
  // //       ? () => import("../views/test-env/TestEnv.vue")
  // //       : undefined,
  // //   redirect:
  // //     constant.MODE !== "development"
  // //       ? {
  // //           name: "Home",
  // //         }
  // //       : undefined,
  // // },
  // {
  //   path: "*",
  //   redirect: {
  //     name: "Home",
  //   },
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
